import React, { useState, useEffect, useContext } from 'react';
import sistemaListStore, { sistemaListShowModal, sistemaListUpdateProps } from "../../../../../componentes/SistemaList/ThisMainComponent/thisStore";

import { Container, BodyColuna, ThisCard, ThisCardProj, ThisCardColor, ThisProgress } from './styles';
import { Label, Input, Select } from "~/componentes/CustomForm";
import api from '~/services/api';

import IconData from '~/assets/icones/IconData.svg';

function CustomBodyContent({
  data,
  idCliente,
  setIdCliente,
  idEtapa,
  setIdEtapa,
  clientes,
  etapas,
  setMountedData,
}) {
  // const { state, dispatch } = useContext(sistemaListStore);
  // const { show, create, edit, destroy, filter } = state?.modal || {};
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  const [projetos, setProjetos] = useState(data);
  const [heightColBody, setHeightColBody] = useState(0);

  // dispatch(sistemaListShowModal({ edit: true, editShow: true }));
  useEffect(() => {
    setProjetos(data);
  }, [data]);

  return (
    <Container>
      <div className='content-projetos'>
        <div className='header'>
          <div className='titulo'>
            <img src={require('~/assets/menus/ativo/menu-projetos.svg')} alt={"Projetos"} />
            <h4 className="title">Projetos</h4>
          </div>
          <div className='filtro'>
            <div className='item'>
              <Select
                isString
                list={{ list: clientes, value: "id", label: "nomeFantasia" }}
                name="idCliente"
                firstOption="Todos Clientes"
                defaultValue={idCliente}
                onChange={(e) => {
                  const v = e.currentTarget.value || null;
                  setIdCliente(v);
                }}
              />
            </div>
          </div>
        </div>
        <div className='body'>
          <BodyColuna className='body-left' {...{ height: heightColBody + "em" }}>
            <div className='body-content'>
              {etapas?.map((thisData, a) => (
                <ThisCard>
                  <div className={thisData?.id === idEtapa ? 'item ativo' : 'item'}
                    onClick={() => {
                      let dados = [];
                      for (const item of data) {
                        if (thisData?.id == item?.idEtapa) {
                          dados.push({ ...item });
                        }
                      }

                      setProjetos(dados);
                      setIdEtapa(thisData?.id);
                    }}
                  >
                    <div className="limite"></div>
                    <div className='item-colunas'>
                      <div className="item-col-quant">
                        <p className="quant">{thisData?.quantidadeProjeto}</p>
                      </div>
                      <div className='row-coluna'>
                        <p>{thisData?.titulo?.length > 50 ? thisData?.titulo?.substr(0, 50) + "..." : thisData?.titulo}</p>
                      </div>
                    </div>
                  </div>
                </ThisCard>
              ))}
            </div>
          </BodyColuna>
          <BodyColuna className='body-right' {...{ height: heightColBody + "em" }}>
            <div className='body-content'>
              <div className="content-right">
                {projetos?.map((thisData, i) => (
                  <ThisCardProj
                    className={
                      linhaAtiva === thisData?.id
                        ? 'card-item ativo'
                        : 'card-item'
                    }
                    {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
                    key={thisData?.id || i}
                    id={thisData?.id || i}
                    index={i}
                    ativo={linhaAtiva === thisData?.id ? true : false}
                    onClick={() => {
                      setMountedData(thisData);
                    }}
                  >
                    <div className="card-header">
                      <div className="card-header-top">
                        <p className="codigo">#{thisData?.codigo}</p>
                      </div>
                      <p className="titulo">{thisData?.titulo}</p>
                      <p className="cliente">
                        {thisData?.cliente?.nomeFantasia}
                      </p>
                    </div>
                    <div className="card-footer">
                      <div className='card-footer-top'>
                        <div className="content-progress">
                          <div className="card-content">
                            <p className="titulo">{thisData?.horaUsada}h/{thisData?.horaTotal}h</p>
                            <div className="progress">
                              <ThisProgress backgound="#34639C" width={((thisData?.horaUsada * 100) / thisData?.horaTotal) > 100 ? 100 : ((thisData?.horaUsada * 100) / thisData?.horaTotal) + "%"} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='card-footer-bottom'>
                        <div className="card-footer-data">
                          <div className="fundo-img">
                            <img src={IconData} alt="IconData" />
                          </div>
                          <p className="data">
                            {"De " + ((new Date(thisData?.previsaoInicio).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}
                            {" Até " + ((new Date(thisData?.previsaoEntrega).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}
                          </p>
                        </div>
                        <div className="card-footer-priori">
                          <ThisCardColor cor={thisData?.prioridade?.cor} />
                          <p className="titulo">
                            {thisData?.prioridade?.titulo}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ThisCardProj>
                ))}
              </div>
            </div>
          </BodyColuna>
        </div>
      </div>
    </Container>
    // <Container>
    //   <div className="content-oc">
    //     <ScrollOS>
    //       <div className="display-oc">
    //         {etapas?.map((thisEtapa, i) => (
    //           <ThisCol key={thisEtapa?.id || i} id={thisEtapa?.id || i} index={i}>
    //             <div className="list-header">
    //               <img src={IconGroup} alt="Vazio" />
    //               <p className="titulo">{thisEtapa?.titulo}</p>
    //               <img className="max" src={IconMax} alt="Vazio" />
    //             </div>
    //             <div className="list-body">
    //               {data?.map(
    //                 (thisData, i) =>
    //                   thisData?.idEtapa == thisEtapa?.id && (
    //                     <ThisCard
    //                       className={
    //                         linhaAtiva === thisData?.id
    //                           ? 'card-item ativo'
    //                           : 'card-item'
    //                       }
    //                       {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
    //                       key={thisData?.id || i}
    //                       id={thisData?.id || i}
    //                       index={i}
    //                       ativo={linhaAtiva === thisData?.id ? true : false}
    //                     >
    //                       <div className="card-header">
    //                         <div className="card-header-top">
    //                           <p className="codigo">#{thisData?.codigo}</p>
    //                           <p className="data">{((new Date(thisData?.dataProjeto).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
    //                         </div>
    //                         <p className="titulo">{thisData?.titulo}</p>
    //                         <p className="cliente">
    //                           {thisData?.cliente?.nomeFantasia}
    //                         </p>
    //                       </div>
    //                       <div className="card-footer">
    //                         <div className="card-footer-priori">
    //                           <ThisCardColor cor={thisData?.prioridade?.cor} />
    //                           <p className="titulo">
    //                             {thisData?.prioridade?.titulo}
    //                           </p>
    //                         </div>
    //                         <p className="responsavel">
    //                           Coord.: {thisData?.coordenador?.nome}
    //                         </p>
    //                       </div>
    //                     </ThisCard>
    //                   ),
    //               )}
    //             </div>
    //           </ThisCol>
    //         ))}
    //       </div>
    //     </ScrollOS>
    //   </div>
    // </Container>
  );
}

export default CustomBodyContent;
